import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  padding: 1.6rem;
  align-self: center;
  justify-content: center;
  ${({ theme }) => theme.media.laptop`
    padding: 2rem 3.6rem 3.6rem 3.6rem;
    max-width: 50rem;
    justify-self: center;
  `};
  /* #checkout-container {
    background: red;
  }
  .button-cancel_wrapper_SdD8 {
    display: none !important;
  } */
`;
